import {useContext} from "react";
import { Paper, Typography, Grid } from "@mui/material";
import { EventContext } from "../../../../../contexts/EventContext";
import SettingSwitch from "../components/SettingsSwitch";

const EventAccess = ({ settings, handleChange }) => {
    const { pairingEvent } = useContext(EventContext);
  return (
    <Paper sx={{ p: 3 }}>
      <Typography variant="subtitle1" sx={{ mb: 2 }}>
        Event Access
      </Typography>

      <Typography variant="caption" sx={{ display: "block", mb: 3 }}>
        Control event visibility, waitlist availability, and attendee presence
        tracking.
      </Typography>

      <Grid container>
        {/* Display Event */}
        <Grid item xs={12}>
          <SettingSwitch
            label="Display Event"
            checked={settings.display}
            onChange={() => handleChange("display", !settings.display)}
            description="Determines if event is visible in Browse Events and the Home tab."
          />
        </Grid>

        <Grid item xs={12}>
          <SettingSwitch
            label="Wait List Enabled"
            checked={settings.waitListEnabled}
            onChange={() =>
              handleChange("waitListEnabled", !settings.waitListEnabled)
            }
            description="If toggled on, then users will be able to add themsleves to the waitlist for sold out ticket types"
          />
        </Grid>
        <Grid item xs={12}>
          <SettingSwitch
            label="Track Attendee Presence"
            checked={
              pairingEvent?.pairingEventType === "dinner"
                ? true
                : settings.trackIsPresent
            }
            disabled={pairingEvent?.pairingEventType === "dinner"}
            onChange={() =>
              handleChange("trackIsPresent", !settings.trackIsPresent)
            }
            description="If toggled on, you will see if an attendees ticket has been scanned and you will be able to manually mark whether an attendee is present at the event."
          />
        </Grid>
      </Grid>
    </Paper>
  );
};

export default EventAccess;
